import { render } from "./ComparePage.vue?vue&type=template&id=26f63596&scoped=true"
import script from "./ComparePage.vue?vue&type=script&lang=js"
export * from "./ComparePage.vue?vue&type=script&lang=js"

import "./ComparePage.vue?vue&type=style&index=0&id=26f63596&scoped=true&scss=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f63596"]])

export default __exports__